export default __webpack_public_path__ + "static/media/upc-logo-branco.e826c940.png";